import React, { useState } from 'react';
import { TableTransfer } from '@common/components';
import { filterableColumnBuilder } from 'works/legacy/lib/table-filters-helper';
import { OrganizationUnitType } from '@institutions/graphql';

type Props = {
  selectedOrganizationUnitIds: string[];
  onOrganizationUnitIdsChange: (organizationUnitIds: string[]) => void;
  organizationUnits: OrganizationUnitType[];
  loading: boolean;
};

function generateRowKey(data: OrganizationUnitType[]) {
  return data.map((unit) => ({
    key: unit.id,
    selectKey: unit.department.id,
    ...unit,
  }));
}

const column = filterableColumnBuilder<OrganizationUnitType>({});

const tableColumns = [
  column({
    key: 'name',
    title: 'Unit Name',
  }),
  column({
    key: 'clinicalUnit',
    dataIndex: ['clinicalUnit', 'displayName'],
    title: 'Unit',
  }),
  column({
    key: 'costCenter',
    title: 'Cost Center',
  }),
  column({
    dataIndex: ['department', 'organizationBusiness', 'name'],
    key: 'department',
    title: 'Facility',
  }),
];

export function MembersUpdateLocationsStepSelectLocations({
  selectedOrganizationUnitIds,
  onOrganizationUnitIdsChange,
  loading,
  organizationUnits,
}: Props) {
  const [selectedKeys, setSelectedKeys] = useState<string[]>([]);

  function onSelectChange(
    sourceSelectedKeys: string[],
    targetSelectedKeys: string[]
  ) {
    const newSelectedKeys = [...sourceSelectedKeys, ...targetSelectedKeys];

    setSelectedKeys(newSelectedKeys);
  }

  return (
    <TableTransfer
      selectKeyEnabled
      loading={loading}
      className="update-locations-step"
      dataSource={generateRowKey(organizationUnits || [])}
      targetKeys={selectedOrganizationUnitIds}
      selectedKeys={selectedKeys}
      onSelectChange={onSelectChange}
      disabled={false}
      onChange={onOrganizationUnitIdsChange}
      columns={tableColumns}
      showSearch
    />
  );
}
